import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const CompanyCity = ({ register, error }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('headquarterCity', {
          required: t('mainReporting:form.mandatory'),
        })}
        label={t('mainReporting:form.companyCity.label')}
        placeholder={t('mainReporting:form.companyCity.placeholder')}
      />
      <InputError error={error} />
    </>
  )
}

export default CompanyCity
